import { gql } from "@apollo/client";
export const SIGNUPMUTATION = gql`
  mutation SignupUser(
    $email: String!
    $password: String!
    $company_name: String!
    $name: String!
    $lastname: String!
    $phone: String!
  ) {
    signUp(
      email: $email
      password: $password
      company_name: $company_name
      name: $name
      lastname: $lastname
      phone: $phone
    ) {
      token
      user {
        id
        name
        lastname
        subuser_id
        privileges
        partner {
          id
          status
          company_name
          owner_name
          owner_lastname
          logo
          branches
          account_type
          stripe_connect_status
        }
        branch {
          id
          name
        }
      }
      settings {
        id
        type
        pref_key
        pref_value
        is_global
      }
    }
  }
`;

export const GET_REFERRAL_CODE_QUERY = `
  query GetReferralCode($code: String!) {
    getReferralCode(code: $code) {
      id
      code
      status
      referral_link
      user {
        name
        lastname
      }
    }
  }
`;

export const REGISTER_REFERRAL_CONVERSION_MUTATION = `
  mutation RegisterReferralConversion($code: String!, $partner_id: Int!) {
    registerReferralConversion(code: $code, partner_id: $partner_id) {
      id
      status
      registered_at
    }
  }
`;
